export default __webpack_public_path__ + "static/media/element_spec_12.7f1a7b56.webp";